import { cn } from "@/lib/utils";

// This is our default page content component, which sets max-width and default padding
export default function PageContent({
  className,
  children,
}: {
  className?: string;
  children: React.ReactNode;
}) {
  return (
    <section
      className={cn(
        "py-12 container max-w-6xl mx-auto md:px-4 px-4 sm:px-4",
        className
      )}
    >
      {children}
    </section>
  );
}
